/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostProcessingMemoryForKubernetesAgent extends models.BaseCostProcessingMemory {
    constructor() {
        super();
        this.setDiscriminator("CostProcessingMemoryForKubernetesAgent");
    }

    getFixupPrototypeFunction() { return CostProcessingMemoryForKubernetesAgent.fixupPrototype; }

    static newInstance(model: Partial<CostProcessingMemoryForKubernetesAgent>): CostProcessingMemoryForKubernetesAgent {
        let obj = Object.assign(new CostProcessingMemoryForKubernetesAgent(), model);
        CostProcessingMemoryForKubernetesAgent.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostProcessingMemoryForKubernetesAgent>): CostProcessingMemoryForKubernetesAgent {
        if (!model) return null;
        return CostProcessingMemoryForKubernetesAgent.newInstance(<CostProcessingMemoryForKubernetesAgent> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostProcessingMemoryForKubernetesAgent) {
        if (!obj) return;

        models.CostProcessingMemoryForKubernetesAgent.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostProcessingMemoryForKubernetesAgent): boolean {
        if (models.BaseCostProcessingMemory.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostProcessingMemoryForKubernetesAgent.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.periods) {
            for (let val of this.periods) {
                models.CostProcessingPeriodMemoryForKubernetesAgent.fixupPrototype(val);
            }
        }
    }

    /**
     * Processed billing periods
     */
    periods: Array<models.CostProcessingPeriodMemoryForKubernetesAgent>;

}
